import { useNavigate } from "react-router-dom";
import OdobrenjeKomentar from "./OdobrenjeKomentar";

function CoursePick({ context }) {
  const navigate = useNavigate();
  const {
    application,
    commentModal,
    course,
    evidentionUserID,
    fetchApplicationCallback,
  } = context;

  const fallbackData = commentModal?.[course] || {};
  const resolvedUserId = application?.userId ?? fallbackData?.userId;
  const resolvedApplicationId = application?.id ?? fallbackData?.id;
  const resolvedMentorReview =
    application?.mentorReview ?? fallbackData?.mentorReview;
  const resolvedIsReferadaAccepted =
    application?.isReferadaAccepted ?? fallbackData?.isReferadaAccepted;
  const isMentorAccepted =
    application?.isMentorAccepted ?? fallbackData?.isMentorAccepted;
  const mentorAcceptedAt =
    application?.mentorAcceptedAt ?? fallbackData?.mentorAcceptedAt;
  const referadaAcceptedAt =
    application?.referadaAcceptedAt ?? fallbackData?.referadaAcceptedAt;
  const acceptanceAuthor =
    application?.acceptanceAuthor ?? fallbackData?.acceptanceAuthor;
  const acceptanceAuthorId =
    application?.acceptanceAuthorId ?? fallbackData?.acceptanceAuthorId;
  const reviewAuthor = application?.reviewAuthor ?? fallbackData?.reviewAuthor;
  return (
    <div>
      <OdobrenjeKomentar
        onClose={() => {
          navigate(-1);
        }}
        mentorReview={resolvedMentorReview}
        firstName={application?.User?.firstName}
        lastName={application?.User?.lastName}
        userId={resolvedUserId}
        applicationId={resolvedApplicationId}
        course={application?.course || course}
        fetchApplication={
          evidentionUserID ? () => {} : fetchApplicationCallback
        }
        evidentionUserID={evidentionUserID ?? null}
        isReferadaAccepted={resolvedIsReferadaAccepted}
        isMentorAccepted={isMentorAccepted}
        mentorAcceptedAt={mentorAcceptedAt}
        referadaAcceptedAt={referadaAcceptedAt}
        acceptanceAuthor={acceptanceAuthor}
        acceptanceAuthorId={acceptanceAuthorId}
        reviewAuthor={reviewAuthor}
      />
    </div>
  );
}
export default CoursePick;
